export class HttpError {
  constructor(public originalError?: any) {
  }
}
